<div class="error-page-container">
  <div class="logo-container">
    <img class="logo-image" [ngStyle]="('design' | env).logoStyle" [src]="('design' | env).logo">
    @if (('design' | env).logoText) {
      <div class="logo-text ml-2">{{ ('design' | env).logoText }}</div>
    }
  </div>
  @switch (error) {
    @case ('account-not-found') {
      <div class="error-page-title mt-5 mb-3 px-3 text-center">{{ 'EXTERNALS.AD_ERROR.ACCOUNT_NOT_FOUND' | translate }}</div>
    }
    @case ('permission-denied') {
      <div class="error-page-title mt-5 mb-3 px-3 text-center">{{ 'EXTERNALS.AD_ERROR.PERMISSION_DENIED' | translate }}</div>
    }
    @default {
      <div class="error-page-title mt-5 mb-3 px-3 text-center">{{ 'EXTERNALS.AD_ERROR.INTERNAL_ERROR' | translate }}</div>
    }
  }
  <div class="error-page-message px-3" [innerHTML]="'EXTERNALS.AD_ERROR.CONTACT_MAIL' | translate:('design' | env)"></div>
</div>